import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-agg',
  templateUrl: './agg.component.html',
  styleUrls: ['./agg.component.scss']
})
export class AggComponent implements OnInit {

  exposition: CardContent = {
    title: 'Aktiv gegen Grippe',
    subtitle: 'Monitor the activity of influenza-like-illness',
    image_source: 'assets/images/Aktiv-gegen-Grippe.jpg',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Client / Partners</h4>ACQUISTO Inter BV, InfluenzaNet, FP7 ',
      '<h4>Methods</h4>Science Communication, Website development',
      '<h4>Technology / Skills</h4>OSM, Django, Python',
      '<h4>Term</h4>2010 - 2012',
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
